// extracted by mini-css-extract-plugin
export default {"root":"ButtonCard_root__xcA0f","titleWrapper":"ButtonCard_titleWrapper__IK6-+","switch":"ButtonCard_switch__eKHmx","formItem":"ButtonCard_formItem__u3O5I"};